import { createExperimentHook } from 'src/components/experiment';

export type SearchResultLayoutExperimentType =
  | boolean
  | 'wide'
  | 'without panorama'
  | 'wide and without panorama';

export const useSearchResultLayoutExperiment =
  createExperimentHook<SearchResultLayoutExperimentType>(
    'search-result-layout',
    false,
    {
      wide: 'wide',
      withoutPanorama: 'without panorama',
      wideAndWithoutPanorama: 'wide and without panorama',
    }
  );

export type PanoramaAdInContentExperimentType =
  | boolean
  | 'trailing skyscraper without top panorama ad'
  | 'trailing skyscraper without top panorama ad with panorama ad in content';

export const usePanoramaAdInContentExperiment =
  createExperimentHook<PanoramaAdInContentExperimentType>(
    'panorama-ad-in-content',
    false,
    {
      trailingSkyscraperWithoutTopPanoramaAd:
        'trailing skyscraper without top panorama ad',
      trailingSkyscraperWithoutTopPanoramaAdWithPanoramaAdInContent:
        'trailing skyscraper without top panorama ad with panorama ad in content',
    }
  );

export const useKWLPLimitProducts = createExperimentHook(
  'kwlp-limit-products',
  100,
  {
    items24: 24,
    items48: 48,
  }
);

export const useKWLPDeprioritizeNoImageOffers = createExperimentHook(
  'kwlp-deprioritize-no-image-offers',
  false,
  {
    deprioritize: true,
  }
);

export const useShowAllVariantsExperiment = createExperimentHook(
  'show-all-variants',
  false,
  {
    show: true,
  }
);

export const useNewPriceHistoryExperiment = createExperimentHook(
  'price-history-new',
  false,
  {
    new: true,
  }
);

export const useSponsoredProductsExperiment = createExperimentHook(
  'sponsored-products',
  false,
  { show: true }
);

export const useHideFilterTicksExperiment = createExperimentHook(
  'hide-filter-ticks',
  false,
  { hide: true }
);
